import React from 'react';
import { useStyles } from './ContextImageView.styles';
import { useFlowData } from '../../Context/FlowDataProvider';

export type ContextImageViewProps = {};

export const ContextImageView: React.FC<ContextImageViewProps> = () => {
  const styles = useStyles();
  const firstName = useFlowData()?.firstName;
  return (
    <div className={styles.contextImageViewContainer}>
      {firstName && (
        <div className={styles.pageContext}>
          <div className={styles.pageTitle}>{`${firstName}'s Blueprint`}</div>
          <div className={styles.pageSubTitle}>
            {'Three weeks to see yourself, your life, and what may bring them into alignment.'}
          </div>
        </div>
      )}
    </div>
  );
};
